import {FragmentElement, FragmentText, FragmentVariable} from './types';

export const isFragmentText = (
    fragment: FragmentElement,
): fragment is FragmentText => {
    return fragment.kind === 'text';
};

export const isFragmentVariable = (
    fragment: FragmentElement,
): fragment is FragmentVariable => {
    return fragment.kind === 'variable';
};
